import { TxnType } from "../../types";

interface BrandSetting {
    displayName:string,
    showSubscription:boolean,
    showHelp:boolean,
    inventorySetting:boolean, //true for enable, false for disabled by default
    showBizCreation:boolean,
    showBranchCreation:boolean,
    hiddenReports:string[],
    hideSignup:boolean,
    hideAuthFooter:boolean,
    hideTxnTypes:string[],
    appLoginText?:string,
    agentName:string,
    showPropertyAttr?:boolean,
    hideCopyRight?:boolean,
    hideContactGroupAttr?:boolean
    aiAvatar:string;
    favicon: string;
    showForMainBrand?:boolean;
    showMarketingWidget?:boolean;
    // When true, a business must explicitly opt in (BizSettings.enableRecurrence) before
    // recurrence runs for it — Recurring Billing shows a self-service toggle for this.
    // Mirrors BrandConfig.recurrenceRequiresBizOptIn on the backend (mail.static-values.ts).
    recurrenceRequiresBizOptIn: boolean;
}

export const brand = import.meta.env.VITE_APP_LABEL || 'mybooks'

// Define settings for different brands
const brandSettingsMap: Record<string, BrandSetting> = {
    mybooks: {
      displayName: "myBooksAi",
      showSubscription: true,
      showHelp: true,
      inventorySetting: true, // Enabled by default
      showBizCreation: true,
      showBranchCreation: true,
      hiddenReports: [],
      hideSignup: false,
      hideAuthFooter:false,
      hideTxnTypes: [],
      agentName:'myBooksAi',
      aiAvatar:'avatars/ai_accountant.png',
      favicon:'/media/favicon.ico',
      showForMainBrand:true,
      showMarketingWidget:true,
      recurrenceRequiresBizOptIn: false
    },
    munily: {
      displayName: "Munily",
      showSubscription: false,
      showHelp: false,
      inventorySetting: false, // Enabled
      showBizCreation: false,
      showBranchCreation: false,
      hiddenReports: ["sales-by-salesperson","sales-order-report","stock-balance","proforma-invoice-report","stock-transactions","delivery-report"],
      hideSignup: true,
      hideAuthFooter:true,
      hideTxnTypes: [TxnType.ProformaInvoice, TxnType.Delivery,TxnType.SalesOrder,TxnType.StockAdjustment],
      appLoginText:' ',
      agentName:'Mario AI',
      showPropertyAttr:true,
      hideCopyRight:true,
      hideContactGroupAttr:true,
      aiAvatar:'avatars/munily-mario.jpg',
      favicon:'/media/logos/munily.ico',
      showMarketingWidget:false,
      recurrenceRequiresBizOptIn: true
    },
    aiprimebooks: {
      displayName: "AiPrimeBooks",
      showSubscription: false,
      showHelp: false,
      inventorySetting: true, // Enabled
      showBizCreation: true,
      showBranchCreation: true,
      hiddenReports: [],
      hideSignup: false,
      hideAuthFooter:true,
      hideTxnTypes: [],
      appLoginText:' ',
      agentName:'Books Ai',
      showPropertyAttr:false,
      hideCopyRight:true,
      hideContactGroupAttr:true,
      aiAvatar:'avatars/ai_accountant.png',
      favicon:'/media/logos/aiprimebooks.ico',
      showMarketingWidget:false,
      recurrenceRequiresBizOptIn: false
    }
  };

// Get the settings based on the brand, defaulting to "mybooks"
export const brandSettings: BrandSetting = brandSettingsMap[brand] || brandSettingsMap["mybooks"];